module.exports = __webpack_public_path__ + "img/list-pattern1.61d65e2.svg";